import { Fragment, ReactNode } from 'react';

export interface Props {
  children: ReactNode;
  count: number;
}

/* istanbul ignore next */
const Repeat = ({ children, count = 1 }: Props) => (
  <>
    {Array(Math.max(0, count))
      .fill(null)
      .map((_, rowIndex) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={rowIndex}>{children}</Fragment>
      ))}
  </>
);

export default Repeat;
